import { GENERATION_TOOL_GROUP, type GenerationToolGroup } from 'src/data/generationTool';

export const MAX_DOCUMENT_WIDTH = 1100;
export const MIN_DOCUMENT_WIDTH = 680;
export const TOOLBAR_HEIGHT = 72;

export const DISPLAY_MODE = {
  document: 'document',
  list: 'list',
};
export type DisplayMode = (typeof DISPLAY_MODE)[keyof typeof DISPLAY_MODE];

export const clampDisplayMode = (mode: DisplayMode, defaultMode?: DisplayMode) => {
  const values = Object.values(DISPLAY_MODE);
  if (values.includes(mode)) {
    return mode;
  }
  return defaultMode;
};

export const PUBSUB_TOPIC_FILL_GUIDANCE_MODE_DATA = Symbol('TOPIC_FILL_GUIDANCE_MODE_DATA');

export const SIDEBAR_GENERIC_ITEM = {
  search: 'search',
  recentlyUsed: 'recently_used',
  moreItems: 'more_items',
  aiChat: 'ai_chat',
} as const;
export type SidebarGenericItem = (typeof SIDEBAR_GENERIC_ITEM)[keyof typeof SIDEBAR_GENERIC_ITEM];

export const SIDEBAR_TOOL_GROUPS: GenerationToolGroup[] = [
  GENERATION_TOOL_GROUP.social,
  GENERATION_TOOL_GROUP.ads,
  GENERATION_TOOL_GROUP.email,
  GENERATION_TOOL_GROUP.landingPage,
  GENERATION_TOOL_GROUP.images,
  GENERATION_TOOL_GROUP.campaigns,
  GENERATION_TOOL_GROUP.customMultiPrompt,
] as const;

export type SidebarSelectedItem = SidebarGenericItem | GenerationToolGroup | (string & {}) | null;

export const GENERATE_USING_OPTIONS = {
  defaultSuggestion: 'Default suggestion',
  removedTalkingPoints: 'Removed talking points',
  manualInstructions: 'Manual instructions',
} as const;
export type GenerateUsingOptions =
  (typeof GENERATE_USING_OPTIONS)[keyof typeof GENERATE_USING_OPTIONS];

export const DEFAULT_SUGGEST_IMPROVEMENT = 'Add engaging adjectives and verbs';

export const IMPORT_BRIEF_SOURCE = {
  fromUrl: 'from_url',
  brandBrief: 'brand_brief',
} as const;
export type ImportBriefSource = (typeof IMPORT_BRIEF_SOURCE)[keyof typeof IMPORT_BRIEF_SOURCE];
